<div class="page-container">
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
  <app-app-bar
    class="sticky"
    *ngIf="getPageState() !== pageState.other"
  ></app-app-bar>
</div>
